import React from 'react';
import { useState, useEffect } from "react";
import { createPortal } from 'react-dom';
import Swal from "sweetalert2";
import { Row, Col, Button } from "reactstrap";
import axios from "axios";
import Sidebar from '../../Sidebar';
import { useNavigate } from 'react-router';
import { BiSave } from "react-icons/bi";
import { IoIosEye } from "react-icons/io";
import { TiCancel } from "react-icons/ti";
import { AiOutlineHome } from "react-icons/ai";
import { useCookies } from 'react-cookie';
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import { moment } from 'moment';
import {displayErrorToast,displayError,parseBoolean,parseBooleanToString} from '../../helpers';
import ErrorToast from '../../ErrorToast';
import FloatingControls from '../../components/FloatingControls';
import LoadingOverlay from '../../components/LoadingOverlay';
import { updateCheckIn,getCheckInNumber,getCheckInDetails,deleteCheckIn,getDivertWorkSchedules } from '../../services/CheckInServices';
import { getUserAllowedPlants } from '../../services/PlantServices';
import{getAllDeliveryChallanForCheckIn, getDeliveryChallanNumber} from '../../services/DeliveryChallanServices';
import { getCheckOutForCHeckIn } from '../../services/CheckOutServices';
import { getCustomerMainDetails } from '../../services/CustomerMainServices';
import { getCustomerSiteDetails } from '../../services/CustomerSiteServices';
import { getDeliveryChallanDetails } from '../../services/DeliveryChallanServices';
import { showBillingPop, showCustomerSitePop, showDeliveryChallanPop, computeAcceptedQtyFromDc, toQtyNumber, goToCheckInMainForm } from './CheckInUtils';
import SummaryIcon from '../../components/SummaryIcon';
import { getDisplayDate, getCurrentDate, getCurrentTime, formatDateForApi } from '../../utils/DateUtils';
import NumberSetting from '../../components/NumberSetting';
import { AccessAlarm } from '@mui/icons-material';
import EditSharpIcon from '@mui/icons-material/EditSharp';
import ViewOnlyTextbox from '../../components/ViewOnlyTextbox';
import { useLocation, Link, useParams, useSearchParams } from 'react-router-dom';
import PremiumPageHeader from '../../components/PremiumPageHeader';
import { getReturnPath, navigateAfterFormSave } from '../../utils/returnNavigation';

function CheckInEdit() {
  const [cookies] = useCookies(['myToken']);
    const [category] = useCookies(['myCategory']);
    const [superuser] = useCookies(['mySuperuser']);
    const [inputs, setInputs] = useState({});
    const [inProgress, setInProgress] = useState(false);
    const [plant, setPlant] = React.useState([]);
    const [plants,setPlants] =React.useState([]);
    const [deliverychallans,setDeliverychallans] =React.useState([]);
    const [checkouts,setCheckouts] =React.useState([]);
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [error, setError] = useState({});
    const [showWeighmentModal, setShowWeighmentModal] = useState(false);
    const [allcheckout,setAllCheckOut]=React.useState([]);
    const [alldeliverychallan,setAllDeliveryChallan]=React.useState([]);
    const [deliverychallan,setDeliveryChallan]=React.useState([]);
    const[selectedcheckout,setSelectedDC] = useState({});
    const[Selectedsite,setSelectedSite]= useState({});
    const[Selectedcustomer,setSelectedCustomer]= useState({});
    const [isLoading, setIsLoading] = useState(true); 
    const [selected_checkout,setSelectedCheckout] = useState({});
    const[selectedWorkSchedule,setSelectedWorkSchedule] = useState({});
    const[balancestatus,setBalanceStatus]= useState([
      { value: "full", label: "Full" },
      { value: "returned", label: "Returned" },
      { value: "wastage", label: "Wastage" },
      { value: "transfer", label: "Divert"},
      { value: "shortage", label: "Shortage"}]);
    const [refreshKey, setRefreshKey] = useState(0);
    const[dcstatus,setDcStatus]= useState([
      { value: "received_with_sign", label: "Received with Sign" },
      { value: "received_without_sign", label: "Received without Sign" },
      { value: "not_received", label: "Not Received" }
    ]);
    const[divertSchedules,setDivertSchedules]= useState([]);
    const RETURN_BALANCE_OPTIONS = [
      { value: "", label: "choose balance status" },
      { value: "full", label: "Full" },
      { value: "returned", label: "Returned" },
      { value: "wastage", label: "Wastage" },
      { value: "transfer", label: "Divert"},
      { value: "shortage", label: "Shortage"}
    ];
    const ACCEPT_WITH_RETURN_OPTIONS = [
      { value: "nill", label: "Nill" },
      { value: "returned", label: "Returned (site return)" },
      { value: "wastage", label: "Wastage" },
      { value: "transfer", label: "Divert"},
    ];
    const needsReturnQty = (status) => ['returned', 'wastage', 'transfer'].includes(status);
    const needsDivert = (status) => status === 'transfer';

    const loadDivertBatchNo = (plantId) => {
      const resolvedPlantId = plantId || inputs.delivery_challan?.work_schedule?.plant?.id;
      if (!resolvedPlantId) {
        return;
      }
      const dcDate = formatDateForApi(inputs.checkin_date || getCurrentDate());
      getDeliveryChallanNumber(cookies, resolvedPlantId, dcDate)
        .then((res) => {
          if (res?.batch_no) {
            setInputs((values) => ({
              ...values,
              batch_no: values.batch_no || res.batch_no,
            }));
          }
        })
        .catch(() => {});
    };

    const loadDivertSchedules = (plantId, notifyIfEmpty = false) => {
      const resolvedPlantId = plantId || inputs.delivery_challan?.work_schedule?.plant?.id;
      if (!resolvedPlantId) {
        setDivertSchedules([]);
        return;
      }
      const checkinDate = formatDateForApi(inputs.checkin_date || getCurrentDate());
      getDivertWorkSchedules(cookies, resolvedPlantId, checkinDate)
        .then((res) => {
          const list = (res.work_schedule_list || []).map((ws) => ({
            value: ws.id,
            label: `${ws.schedule_no} | ${ws.grade?.name || ''} | Bal ${ws.balance_qty} | ${ws.consignee || ''}`,
          }));
          setDivertSchedules(list);
          if (notifyIfEmpty) {
            if (!list.length && res.message) {
              Swal.fire(res.message, '', 'info');
            } else if (!list.length) {
              Swal.fire('No open Work Schedule found at this plant for divert.', '', 'info');
            }
          }
        })
        .catch((error) => {
          setDivertSchedules([]);
          displayError(error?.response?.data, 'Failed to load work schedules');
        });
    };

    React.useEffect(() => {
      if (needsDivert(inputs.balance_status) && inputs.delivery_challan) {
        loadDivertSchedules(inputs.delivery_challan?.work_schedule?.plant?.id);
      }
    }, [
      inputs.balance_status,
      inputs.delivery_challan?.work_schedule?.plant?.id,
      inputs.checkin_date,
    ]);
    // React.useEffect(() => {
    //   setInputs(values => ({...values,
    //       ['checkin_date']: getCurrentDate(),
    //       ['checkin_time']: getCurrentTime(),
    //       ['weighment_slip_date']: getCurrentDate(),
    //       ['weighment_slip_time']: getCurrentTime(),
    //       ['checkout_date']: getCurrentDate()
    //   }))
    //     }, []);

// React.useEffect(() => {
//   getUserAllowedPlants(cookies)
//   .then (
//       plantList => {
//         console.log(JSON.stringify(plantList)+"plantList")
//           const plant = plantList.plant_list.filter(obj => obj.status).map(
//               plant => {
//                   return { value: plant.id, label: plant.plant_alias }
//               }
//           );
//           setPlants(plant);
//       }
//   )
// }, []);
      
      const navigate = useNavigate();
      const location = useLocation();
      const [searchParams] = useSearchParams();
      const returnTo = getReturnPath(location, searchParams);
      const returnToDeliveryChallan = Boolean(returnTo && returnTo.includes('DeliveryChallan'));

    const handleChange = (event) => {
      const name = event.target.name;
      const value = event.target.value;
      if (name === 'tare_weight' || name === 'gross_weight') {
        var tare_weight = document.getElementById('tare_weight').value;
        var gross_weight = document.getElementById('gross_weight').value;     
        if((tare_weight === '') || (tare_weight === NaN) ){
            tare_weight = 0;
        }
        if((gross_weight === '') || (gross_weight === NaN) ){
            gross_weight = 0;
        }
        console.log(tare_weight+"tare_weight")
        console.log(gross_weight+"gross_weight")
        var net_weight = parseFloat(gross_weight) - parseFloat(tare_weight);
        console.log(net_weight+"net_weight")
        setInputs(values => ({...values, ['net_weight']: net_weight})) 
      }
      if (name === 'balance_status') {
        const dcQty = parseFloat(document.getElementById('dc_qty')?.value || inputs?.delivery_challan?.dc_qty || 0);
        const balanceQty = parseFloat(inputs.balance_qty || 0);
        const defaultRet = balanceQty > 0 ? balanceQty : dcQty;
        if (needsReturnQty(value)) {
          setInputs(values => ({
            ...values,
            [name]: value,
            ret_qty: values.ret_qty > 0 ? values.ret_qty : defaultRet,
            other_qty: value === 'transfer' ? (values.other_qty || 0) : 0,
            divert_to_ws: value === 'transfer' ? (values.divert_to_ws || '') : '',
            batch_no: value === 'transfer' ? (values.batch_no || '') : '',
          }));
          if (value === 'transfer') {
            loadDivertSchedules(inputs.delivery_challan?.work_schedule?.plant?.id);
            loadDivertBatchNo(inputs.delivery_challan?.work_schedule?.plant?.id);
          }
          return;
        }
        setInputs(values => ({
          ...values,
          [name]: value,
          ret_qty: 0,
          other_qty: 0,
          divert_to_ws: '',
          batch_no: '',
        }));
        return;
      }
      setInputs(values => ({...values, [name]:value}));
  }
  
  const handleChangeOpeningKmDetails = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    if ( name === 'ending_km') {
         var opening_km = document.getElementById('opening_km').value;
         var ending_km = document.getElementById('ending_km').value;
         document.getElementById('ending_km').setAttribute('min',opening_km);      
         if((opening_km === '') || (opening_km === NaN) ){
          opening_km = 0;
         }
         if((ending_km === '') || (ending_km === NaN) ){
          ending_km = 0;
         }
         console.log(opening_km+"opening_km")
         console.log(ending_km+"ending_km")
        var total_km = parseFloat(ending_km) - parseFloat(opening_km);
        console.log(total_km+"total_km")
        setInputs(values => ({...values, ['total_km']: total_km})) 
    }
    setInputs(values => ({...values, [name]: event.target.value}))
  };
  
  const handleChangeOpeningHmDetails = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    if ( name === 'ending_hm') {
         var opening_hm = document.getElementById('opening_hm').value;
        var ending_hm = document.getElementById('ending_hm').value;
        document.getElementById('ending_hm').setAttribute('min',opening_hm);     
         if((opening_hm === '') || (opening_hm === NaN) ){
          opening_hm = 0;
         }
         if((ending_hm === '') || (ending_hm === NaN) ){
          ending_hm = 0;
         }
         console.log(opening_hm+"opening_hm")
         console.log(ending_hm+"ending_hm")
        var total_hm = parseFloat(ending_hm) - parseFloat(opening_hm);
        console.log(total_hm+"total_hm")
        setInputs(values => ({...values, ['total_hm']: total_hm})) 
    }
    setInputs(values => ({...values, [name]: event.target.value}))
  };

  // Function to handle changes in the Customer's Status dropdown
  const handleChangeCustomerStatusDetails = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const deliveryChallan = inputs.delivery_challan || {};
    const dcQty = toQtyNumber(document.getElementById('dc_qty')?.value ?? deliveryChallan.dc_qty);
    const acceptedField = document.getElementById('accepted_qty');

    if(value === 'accepted'){
        const accepted_qty = computeAcceptedQtyFromDc(deliveryChallan, dcQty);
        const balance_qty = parseFloat((dcQty - accepted_qty).toFixed(2));
        if (acceptedField) {
          acceptedField.setAttribute('readOnly','readOnly');
          acceptedField.style.cursor = "not-allowed";
        }
        setBalanceStatus(ACCEPT_WITH_RETURN_OPTIONS)
        setDcStatus([
          { value: "", label: "choose customer dc status" },
          { value: "received_with_sign", label: "Received with Sign" },
          { value: "received_without_sign", label: "Received without Sign" },
          { value: "not_received", label: "Not Received" }
        ])
        setInputs(values => ({
          ...values,
          [name]: value,
          accepted_qty,
          balance_qty,
          ret_qty: 0,
          other_qty: 0,
          divert_to_ws: '',
          batch_no: '',
          balance_status: "nill",
        }))
        return;
    }
       
   if(value === 'cancelled')
    {
      if (acceptedField) {
        acceptedField.setAttribute('readOnly','readOnly');
        acceptedField.style.cursor = "not-allowed";
      }
      setBalanceStatus(RETURN_BALANCE_OPTIONS);
      setDcStatus([
        { value: "cancelled", label: "Cancelled" }
       ])
      setInputs(values => ({
        ...values,
        [name]: value,
        accepted_qty: 0,
        balance_qty: dcQty,
        ret_qty: dcQty,
        other_qty: 0,
        divert_to_ws: '',
        batch_no: '',
        cus_dc_status: "cancelled",
      }))
      return;
 }
 
    if(value === 'partial_accepted' ){
            const currentAccepted = toQtyNumber(acceptedField?.value ?? inputs.accepted_qty);
            if (acceptedField) {
              acceptedField.removeAttribute('readOnly');
              acceptedField.style.cursor = "pointer";
              acceptedField.setAttribute('max', dcQty);
            }
            const balance_qty = parseFloat((dcQty - currentAccepted).toFixed(2));
            setBalanceStatus(RETURN_BALANCE_OPTIONS)
            setDcStatus([
              { value: "", label: "choose customer dc status" },
              { value: "received_with_sign", label: "Received with Sign" },
              { value: "received_without_sign", label: "Received without Sign" },
              { value: "not_received", label: "Not Received" }
             ])
            setInputs(values => ({
              ...values,
              [name]: value,
              balance_qty,
              ret_qty: 0,
              other_qty: 0,
              divert_to_ws: '',
              batch_no: '',
            }))
            return;
            }
    setInputs(values => ({...values, [name]: event.target.value}))
  };

  const handleChangeAcceptedDetails = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const deliveryChallan = inputs.delivery_challan || {};
    const dcQty = toQtyNumber(document.getElementById('dc_qty')?.value ?? deliveryChallan.dc_qty);
    const accepted_qty = toQtyNumber(value);
    const balance_qty = parseFloat((dcQty - accepted_qty).toFixed(2));
    setInputs(values => ({
      ...values,
      [name]: accepted_qty,
      balance_qty,
    }))
   }
   
  const showCustomerDetails = () => {
    if (inputs.id) {
        getCustomerMainDetails(cookies,inputs.delivery_challan.work_schedule.sales_order_detail.sales_order.consignee.customer.id)
        .then(selectedCustomer => {
            showBillingPop(selectedCustomer)
        })
        }
    }

  const showSiteDetails = () => {
    if (inputs.id) {
        getCustomerSiteDetails(cookies,inputs.delivery_challan.work_schedule.sales_order_detail.sales_order.consignee.id)
        .then(consignee => {
            showCustomerSitePop(consignee)
        })
        }
    }

    const showDeliveryChallanDetails = () => {
      if (inputs.id) {
          getDeliveryChallanDetails(cookies,inputs.delivery_challan.id)
          .then(selected_DC => {
            showDeliveryChallanPop(selected_DC);
          })
          }
      }

    const openWeighmentModal = () => setShowWeighmentModal(true);
    const closeWeighmentModal = () => setShowWeighmentModal(false);

    useEffect(() => {
      if (!showWeighmentModal || typeof document === 'undefined') return undefined;
      const previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = previousOverflow;
      };
    }, [showWeighmentModal]);

      const constructFormData = () => {
        const deliveryChallan = inputs.delivery_challan || {};
        const dcQty = toQtyNumber(deliveryChallan.dc_qty);
        let acceptedQty = toQtyNumber(inputs.accepted_qty);
        let balanceQty = toQtyNumber(inputs.balance_qty);
        if (inputs.customer_status === 'accepted' && !(acceptedQty > 0) && dcQty > 0) {
          acceptedQty = computeAcceptedQtyFromDc(deliveryChallan, dcQty);
          balanceQty = parseFloat((dcQty - acceptedQty).toFixed(2));
        }
        return {
          id:inputs.id,
          weighment_slip_no:inputs.weighment_slip_no,
          weighment_slip_date:getDisplayDate(inputs.weighment_slip_date),
          weighment_slip_time:inputs.weighment_slip_time,
          gross_weight:inputs.gross_weight?parseInt(inputs.gross_weight):0,
          tare_weight:inputs.tare_weight?parseInt(inputs.tare_weight):0,
          net_weight:inputs.net_weight?parseInt(inputs.net_weight):0,
          ending_km:inputs.ending_km?parseInt(inputs.ending_km):0,
          total_km:inputs.total_km?parseInt(inputs.total_km):0,
          ending_hm:inputs.ending_hm?parseInt(inputs.ending_hm):0,
          total_hm:inputs.total_hm?parseInt(inputs.total_hm):0,
          customer_status:inputs.customer_status,
          accepted_qty:acceptedQty,
          balance_qty:balanceQty,
          balance_status:inputs.balance_status,
          cus_dc_status:inputs.cus_dc_status,
          ret_qty: parseFloat(inputs.ret_qty || 0),
          other_qty: parseFloat(inputs.other_qty || 0),
          divert_to_ws: inputs.divert_to_ws || null,
          divert_batch_no: needsDivert(inputs.balance_status) ? parseInt(inputs.batch_no || 0, 10) : 0,
          }
      } 
        
    const handleSubmit = (event) => {
      event.preventDefault();
     
      if ((Object.values(error).every(x => !x)) && isSubmitting) {
          if (needsDivert(inputs.balance_status) && !inputs.divert_to_ws) {
            Swal.fire('Divert Work Schedule is required when Balance Status is Divert.', '', 'warning');
            return;
          }
          if (needsDivert(inputs.balance_status) && !(parseInt(inputs.batch_no || 0, 10) > 0)) {
            Swal.fire('Batch No is required when Balance Status is Divert.', '', 'warning');
            return;
          }
          if (needsReturnQty(inputs.balance_status) && !(parseFloat(inputs.ret_qty) > 0)) {
            Swal.fire('Return Qty must be greater than zero.', '', 'warning');
            return;
          }
          Swal.fire({title: (inputs.customer_status === 'cancelled'? 'This Will be Deleted if this Cancelled DC is last?. ' : '') + 'Do you want to Update?', 
            showCancelButton: true,  
            confirmButtonText: `Yes`,  
            cancelButtonText: `No`,
            }).then((result) => {  
              if (result.isConfirmed) 
              { 
                updateCheckIn(cookies, constructFormData(),id)
                .then(function (response) {
                  const divertNo = response?.data?.divert_dc_no;
                  if (divertNo) {
                    Swal.fire('Updated!', `Divert DC No: ${divertNo}`, 'success').then(() => {
                      goToCheckInMainForm(navigate, location, returnTo);
                    });
                  } else {
                    Swal.fire('Updated!', '', 'success').then(() => {
                      goToCheckInMainForm(navigate, location, returnTo);
                    });
                  }
                })
                .catch((error) =>
                {
                  console.log(error.response.data);
                  displayError(error.response.data,"Update Failed");
                })
              } 
              else if (result.isDismissed) 
              {    
                Swal.fire('Not Updated', '', 'info')  
              }
            });
      }
      else
      {
        Swal.fire('Please check * marked fields are filled and details given are valid...', '', 'info')   
      }
  }
  const {id}=useParams()
  
  React.useEffect(() => {
    if (id) {
      setInProgress(true);
      getCheckInDetails(cookies, id)
        .then(response => {
          setInProgress(false);
          setInputs(response)
          setInputs(values => ({...values,['weighment_slip_date']:getDisplayDate(response.weighment_slip_date),
          ['checkin_date']: getDisplayDate(response.checkin_date),
          ['checkout_date']: getDisplayDate(response.checkout_date),
          ['plant_alias']:response.delivery_challan.work_schedule.plant.alias_name,
          ret_qty: response.ret_qty || 0,
          other_qty: response.other_qty || 0,
          divert_to_ws: response.divert_to_ws || '',
          batch_no: response.divert_batch_no || ''}));
          if(response.customer_status === 'accepted'){
            setBalanceStatus(ACCEPT_WITH_RETURN_OPTIONS)
            document.getElementById('accepted_qty').setAttribute('readOnly','readOnly');
            document.getElementById('accepted_qty').style.cursor = "not allowed";
          }
          else if(response.customer_status === 'cancelled'){
            document.getElementById('accepted_qty').setAttribute('readOnly','readOnly');
            document.getElementById('accepted_qty').style.cursor = "not allowed";
          setDcStatus([
            { value: "cancelled", label: "Cancelled" }
           ])
           setBalanceStatus(RETURN_BALANCE_OPTIONS)
          }
          else if(response.customer_status === 'partial_accepted' ){
            document.getElementById('accepted_qty').removeAttribute('readOnly');
            document.getElementById('accepted_qty').style.cursor = "pointer";
            document.getElementById('accepted_qty').setAttribute('max',response.delivery_challan.dc_qty);
            setBalanceStatus(RETURN_BALANCE_OPTIONS)
          }
          if (response.balance_status === 'transfer') {
            loadDivertSchedules(response.delivery_challan?.work_schedule?.plant?.id);
          }
            
            getCustomerMainDetails(cookies,response.delivery_challan.work_schedule.sales_order_detail.sales_order.consignee.customer.id)    
            .then(customerObject => {              //Set the details of the customer in the form fields
                setSelectedCustomer(customerObject)
                })
  
            getCustomerSiteDetails(cookies,response.delivery_challan.work_schedule.sales_order_detail.sales_order.consignee.id)
                  .then(customerObject => {                     //Set the details of the customer in the form fields
                      setSelectedSite(customerObject);
                  });
            if (response.show_msg){
              Swal.fire(response.remarks, '', 'info') 
            }
        })
        .catch(error => {
          setInProgress(false);
         displayError(error.response.data, "Loading Failed");
        });
      }
    }, []);

const Reload = () => {
window.location.reload();
}      
const Cancel = () => {
setInputs(() => "")
}

const view = () => {
  navigateAfterFormSave(navigate, location, '/CheckInTable', searchParams);
} 

const Back = () => {
  if (returnTo) {
    navigate(returnTo, { replace: true });
    return;
  }
  navigate('/Home')
}

return (
        <>
 <div id="outer-container" className="App" >
 <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
 <ErrorToast/>
 <LoadingOverlay inProgress={inProgress}/>
 <div id="page-wrap">
 <form onSubmit={handleSubmit} >
 <div className="premium-page-header-wrap">
              <PremiumPageHeader
                module="GATE"
                title="Vehicle Check In"
                subtitle="Update vehicle check-in and delivery challan acceptance details."
                modeLabel="EDIT MODE"
              />
            </div>
            <FloatingControls tableLink="/CheckInTable" enableCancel={false}/>

            <div className="form-content-wrap">
            <div className="form-row table-bordered  shadow p-2 my-2 border-secondary p-2 mb-3  form-control-panel">
            <Row className="form-equal-height-row no-gutters"> 
                    <Col xl={6} lg={6} md={6}> 
                    <div className="form-row p-2 my-2 border-secondary p-2 mb-3 form-control-panel form-panel-fill">   
           {/* <label htmlFor="plant_id" className="form-group col-sm-5 text-right"> Plant Location </label>
               <select id="plant_id"  required onChange={handleChangePlant}name="plant_id" className="form-control col-sm-6  browser-default custom-select  mandatory-form-control"   value={inputs.plant_id || ""}>
               <option value="">Select Plant</option>
                           {plants.map((item) => (
                       <option key={item.value} value={item.value}>
                           {item.label}</option>
                   ))}
               </select> */}
               <ViewOnlyTextbox 
                name="plant_alias" 
                value={inputs.plant_alias|| ""}
                labelClassName="form-group col-sm-5 text-right"
                label="Plant Location"
                inputClassName="form-control col-sm-6"
                />
               {/* <label htmlFor="checkout_no" className="form-group col-sm-5 text-right">Check Out No.</label>
              <select id="checkout_no" required onChange={handleChangeCheckOutDetails} name="checkout_no"  className="form-control col-sm-6  browser-default custom-select  mandatory-form-control" value={inputs.checkout_no || ""}>
                 <option value="">Select Checkout No</option>
                 {checkouts.map((item) => (
                         <option key={item.value} value={item.value}>
                         {(item.label)}
                         </option>
                     ))}
               </select>  */}
               <ViewOnlyTextbox 
                name="checkout_no" 
                value={inputs.checkout_no|| ""}
                labelClassName="form-group col-sm-5 text-right"
                label="Check Out No."
                inputClassName="form-control col-sm-6"
                />
               {/* <ViewOnlyTextbox 
                name="checkout_date" 
                value={inputs.checkout_date|| ""}
                labelClassName="form-group col-sm-5 text-right"
                label="Date & Time"
                inputClassName="form-control col-sm-3"
                />  
                 <ViewOnlyTextbox 
                name="checkout_date" 
                value={inputs.checkout_time|| ""}
                labelClassName="form-group col-sm-5 text-right"
                inputClassName="form-control col-sm-3"
                />   */}
                <label htmlFor="checkout_date" className="form-group col-sm-5 text-right">Date & Time</label>
                <div className="col-sm-6 px-0 form-datetime-pair">
                <input type="date" className="form-control text-right" name="checkout_date" value={inputs.checkout_date || ""} id="checkout_date" readOnly={true} style={{cursor: "not-allowed"}} />
                <input type="time" id="checkout_time"  name="checkout_time"  value={inputs.checkout_time || ""} className="form-control" readOnly={true} style={{cursor: "not-allowed"}}/>
                </div>

                <ViewOnlyTextbox 
                name="vehicle_no" 
                value={inputs.delivery_challan?.vehicle?.name || ""}
                labelClassName="form-group col-sm-5 text-right"
                label="Vehicle No"
                inputClassName="form-control col-sm-6"
                />  
               
                <ViewOnlyTextbox 
                name="delivery_challan_no" 
                value={(inputs.id ? '('+inputs?.delivery_challan?.prefix +')'+inputs?.delivery_challan?.delivery_challan_no : "")}
                labelClassName="form-group col-sm-5 text-right"
                label="DC No"
                inputClassName="form-control col-sm-6"
                showSummaryDetails={showDeliveryChallanDetails}
                />    
              
             <label htmlFor="wsSlDt" className="form-group col-sm-5 text-right">Date & Time</label>
              <div className="col-sm-6 px-0 form-datetime-pair">
              <input type="date" className="form-control" name="checkin_date" value={inputs.checkin_date || ""} id="checkin_date" readOnly={true} style={{ cursor: "not-allowed"}} />
              <input type="time" id="checkin_time" required name="checkin_time"  value={inputs.checkin_time || ""}  readOnly={true}  style={{ cursor: "not-allowed"}} className="form-control"/>
              </div>
                           </div>
               </Col>

           <Col xl={6} lg={6} md={6}> 
           <div className="form-row p-2 my-2 border-secondary p-2 mb-3 form-control-panel form-panel-fill"> 
               <ViewOnlyTextbox 
                name="billing_name" 
                value={inputs?.delivery_challan?.work_schedule?.sales_order_detail?.sales_order?.consignee?.customer?.name || ""}
                labelClassName="form-group col-sm-5 text-right"
                label="Billing Name"
                inputClassName="form-control col-sm-6"
                showSummaryDetails={showCustomerDetails}
                />    
               
                <ViewOnlyTextbox 
                name="project_name" 
                value={inputs?.delivery_challan?.work_schedule?.sales_order_detail?.sales_order?.consignee?.project_name || ""}
                labelClassName="form-group col-sm-5 text-right"
                label="Project/Site Name"
                inputClassName="form-control col-sm-6"
                showSummaryDetails={showSiteDetails}
                /> 

               <ViewOnlyTextbox 
                name="grade" 
                value={inputs?.delivery_challan?.work_schedule?.sales_order_detail?.product?.name || ""}
                labelClassName="form-group col-sm-5 text-right"
                label="Grade"
                inputClassName="form-control col-sm-6"
                />  
             
                <ViewOnlyTextbox 
                name="dc_qty" 
                value={inputs?.delivery_challan?.dc_qty || ""}
                labelClassName="form-group col-sm-5 text-right"
                label="DC Qty"
                inputClassName="form-control col-sm-6"
                />

                <label htmlFor="weighment_details" className="form-group col-sm-5 text-right">Weighment Details</label>
                <div className="col-sm-6 px-0 form-input-with-icon">
                <EditSharpIcon
                  htmlColor="#1565c0"
                  onClick={openWeighmentModal}
                  sx={{ cursor: 'pointer' }}
                />
                </div>
               </div>
           </Col>
           </Row>
</div>

<Row className="form-equal-height-row no-gutters">
<Col xl={12} lg={12} md={12}>
   <Row className="no-gutters">
   <Col xl={3} lg={3} md={6} className="pr-1">
   <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel form-panel-fill form-panel-stack" >
              <div className="form-stack-field">
                <label htmlFor="opening_km" className="form-group mb-0">Opening KM</label>
                <input type="number" className="form-control" id="opening_km" name="opening_km" value={inputs?.opening_km || 0} readOnly={true} style={{ cursor: "not-allowed" }} />
              </div>
              <div className="form-stack-field">
                <label htmlFor="ending_km" className="form-group mb-0">Ending KM</label>
                <input type="number" className="form-control" id="ending_km" name="ending_km" onChange={handleChangeOpeningKmDetails} value={inputs.ending_km || 0} />
              </div>
              <div className="form-stack-field">
                <label htmlFor="total_km" className="form-group mb-0">Total KM</label>
                <input type="number" className="form-control" readOnly={true} id="total_km" name="total_km" value={inputs.total_km || 0} style={{ cursor: "not-allowed" }} />
              </div>
           </div>
   </Col>
   <Col xl={3} lg={3} md={6} className="pl-1 pr-1">
           <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel form-panel-fill form-panel-stack" >
            <div className="form-stack-field">
              <label htmlFor="opening_hm" className="form-group mb-0">Opening HM</label>
              <input type="number" id="opening_hm" name="opening_hm" className="form-control" value={inputs?.opening_hm || 0} readOnly={true} style={{cursor:"not-allowed"}}/>
            </div>
            <div className="form-stack-field">
              <label htmlFor="ending_hm" className="form-group mb-0">Ending HM</label>
              <input type="number" className="form-control" name="ending_hm" id="ending_hm" onChange={handleChangeOpeningHmDetails} value={inputs.ending_hm || 0} />
            </div>
            <div className="form-stack-field">
              <label htmlFor="total_hm" className="form-group mb-0">Total HM</label>
              <input type="number" className="form-control" id="total_hm" name="total_hm" readOnly={true} value={inputs.total_hm || 0} style={{ cursor: "not-allowed" }} />
            </div>
             </div>
   </Col>
   <Col xl={6} lg={6} md={12} className="pl-1">
    <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel form-panel-fill" >
      <label htmlFor="customer_status" className="form-group col-sm-4 text-right">Customer's Status</label>
      <select id="customer_status" name="customer_status" className="form-control col-sm-7  browser-default custom-select mandatory-form-control" required onChange={handleChangeCustomerStatusDetails} value={inputs.customer_status || ""}>
        <option value="">Select</option>
              <option value="accepted">Accepted</option>
              <option value="partial_accepted">Partial Accepted</option>
              <option value="cancelled">Cancelled</option>
      </select><br />

      <label htmlFor="accepted_qty" className="form-group col-sm-4 text-right">Accepted Qty</label>
      <input type="number" step="any" min="0" className="form-control col-sm-7 mandatory-form-control" id="accepted_qty" name="accepted_qty" onChange={handleChangeAcceptedDetails} value={inputs.accepted_qty ?? 0 } readOnly={inputs.customer_status === "accepted" || inputs.customer_status === "cancelled"} style={{ cursor: (inputs.customer_status === "accepted" || inputs.customer_status === "cancelled") ? "not-allowed" : "pointer" }} /><br />
             
      <label htmlFor="balance_qty" className="form-group col-sm-4 text-right">Balance Qty</label>
      <input type="number" className="form-control col-sm-7" id="balance_qty" name="balance_qty" value={inputs.balance_qty || 0 }readOnly={true} style={{ cursor: "not-allowed" }} /><br />

      <label htmlFor="balance_status" className="form-group col-sm-4 text-right">Balance Status</label>
      <select id="balance_status" name="balance_status" className="form-control col-sm-7  browser-default custom-select mandatory-form-control" required onChange={handleChange} value={inputs.balance_status || ""}>
            {balancestatus.map((item) => (
                    <option key={item.value} value={item.value}>
                    {(item.label)}
                    </option>
                ))}
      </select><br />

      {needsReturnQty(inputs.balance_status) && (
        <>
          <label htmlFor="ret_qty" className="form-group col-sm-4 text-right">Return Qty (m3)</label>
          <input type="number" step="0.01" min="0" className="form-control col-sm-7 mandatory-form-control" required id="ret_qty" name="ret_qty" onChange={handleChange} value={inputs.ret_qty ?? 0} /><br />
        </>
      )}

      {needsDivert(inputs.balance_status) && (
        <>
          <label htmlFor="other_qty" className="form-group col-sm-4 text-right">Additional Qty (top-up)</label>
          <input type="number" step="0.01" min="0" className="form-control col-sm-7" id="other_qty" name="other_qty" onChange={handleChange} value={inputs.other_qty ?? 0} /><br />

          <label htmlFor="divert_to_ws" className="form-group col-sm-4 text-right">Divert Work Schedule</label>
          <select id="divert_to_ws" name="divert_to_ws" className="form-control col-sm-7 browser-default custom-select mandatory-form-control" required onChange={handleChange} onFocus={() => loadDivertSchedules(
            inputs.delivery_challan?.work_schedule?.plant?.id,
            true
          )} value={inputs.divert_to_ws || ""}>
            <option value="">Select Work Schedule</option>
            {divertSchedules.map((item) => (
              <option key={item.value} value={item.value}>{item.label}</option>
            ))}
          </select><br />

          <label htmlFor="batch_no" className="form-group col-sm-4 text-right">Batch No</label>
          <input type="number" min="1" className="form-control col-sm-7 mandatory-form-control" required id="batch_no" name="batch_no" onChange={handleChange} value={inputs.batch_no || ""} /><br />
        </>
      )}

      <label htmlFor="cus_dc_status" className="form-group col-sm-4 text-right">DC Status</label>
      <select id="cus_dc_status" name="cus_dc_status" className="form-control col-sm-7  browser-default custom-select mandatory-form-control" required onChange={handleChange}  value={inputs.cus_dc_status || ""}>
        {dcstatus.map((item) => (
                  <option key={item.value} value={item.value}>
                  {(item.label)}
                  </option>
              ))}  
      </select><br/>

      <label htmlFor="editing_dtls" className="form-group col-sm-4 text-right">Editing Dtls</label>
      <textarea type="text" className="form-control col-sm-7" id="editing_dtls" readOnly={true}  value={inputs.editing_dtls||""} name="editing_dtls" style={{ cursor: "not-allowed" }} />
           </div>
  </Col>
  </Row>
  </Col>
        </Row>
    </div>

    <div className="footer text-center">
      <Button type="submit" className="btn btn-twitter" style={{width:"80px",fontWeight:"bold"}} >Update</Button> &nbsp;&nbsp;
      <Button className="btn btn-twitter"  type="button"style={{width: returnToDeliveryChallan ? '180px' : '80px',fontWeight:"bold"}} onClick={view}>{returnToDeliveryChallan ? 'Back to DC' : 'View'}</Button>&nbsp;&nbsp;
      <Button className="btn btn-twitter"  type="button"style={{width:"80px",fontWeight:"bold"}} onClick={Back}>{returnTo ? 'Back' : 'Home'}</Button>
    </div>
  </form>
</div>
</div>
      {showWeighmentModal && typeof document !== 'undefined' && createPortal(
        <div
          className="modal weighment-details-modal show"
          tabIndex="-1"
          role="dialog"
          aria-modal="true"
          onClick={closeWeighmentModal}
        >
          <div
            className="modal-dialog weighment-details-modal-dialog"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="modal-content">
              <div className="weighment-details-modal-header">
                <h5><b>Weighment Details</b></h5>
                <button type="button" className="weighment-details-close-btn" aria-label="Close" onClick={closeWeighmentModal}>×</button>
              </div>
              <div className="modal-body display">
                <div className="form-row table-bordered shadow p-2 my-1 border-secondary form-control-panel">
                  <label htmlFor="weighment_slip_no" className="form-group col-sm-4 text-right">Weighment Slip No.</label>
                  <input type="text" id="weighment_slip_no" name="weighment_slip_no" onChange={handleChange} value={inputs.weighment_slip_no || ""} className="form-control col-sm-7"/>

                  <label htmlFor="weighment_slip_date" className="form-group col-sm-4 text-right">Date & Time</label>
                  <input type="date" className="form-control col-sm-3" name="weighment_slip_date" value={inputs.weighment_slip_date || ""} id="weighment_slip_date" onChange={handleChange} />
                  <input type="time" id="weighment_slip_time" name="weighment_slip_time" onChange={handleChange} value={inputs.weighment_slip_time || ""} className="form-control col-sm-4"/>

                  <label htmlFor="gross_weight" className="form-group col-sm-4 text-right">Gross Weight</label>
                  <input type="number" id="gross_weight" name="gross_weight" onChange={handleChange} value={inputs.gross_weight || 0} className="form-control col-sm-7"/>

                  <label htmlFor="tare_weight" className="form-group col-sm-4 text-right">Tare Weight</label>
                  <input type="number" name="tare_weight" id="tare_weight" onChange={handleChange} value={inputs.tare_weight || 0} className="form-control col-sm-7"/>

                  <label htmlFor="net_weight" className="form-group col-sm-4 text-right">Net Weight</label>
                  <input type="number" id="net_weight" name="net_weight" readOnly style={{ backgroundColor: "white", cursor: "not-allowed" }} value={inputs.net_weight || 0} className="form-control col-sm-7"/>
                </div>
              </div>
              <div className="text-center weighment-details-modal-footer">
                <button type="button" className="btn btn-primary" onClick={closeWeighmentModal}>Close</button>
              </div>
            </div>
          </div>
        </div>,
        document.body
      )}
</>
);
}
export default CheckInEdit;